import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: LayoutComponent[] = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 2,
        rows: 3,
        rowsSize: [4, 0.5, 1],
        rowSpan: {
          "0:0": 2,
        },
        colSpan: {
          "2:0": 2,
        },
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/14/principle/principle-1-inner-hair-chart-1.svg`,
                  },
                },
                styles: {
                  padding: "2%",
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/14/principle/principle-1-inner-hair-chart-2.svg`,
                  },
                },
                styles: {
                  padding: "2%",
                },
              },
            },
          ],
          [
            null,
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: "Filtered signal",
                    scrollbars: false,
                    styles: {
                      fontWeight: 700,
                    },
                  },
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "hint",
                  options: {
                    data:
                      "The Inner Hair Cells (IHC) are responsible for translating the basillar membrane vibration into electrical information for our brain . However, neurotransmitters are released only when the IHC move in a particular direction. This is modeled as a half wave rectifier.",
                    direction: "row",
                  },
                },
                styles: {
                  width: "615px",
                },
              },
            },
          ],
        ],
      },
    },
  },
];

export default components;
